// extracted by mini-css-extract-plugin
export var subtitle = "membership-module--subtitle--rejgG";
export var pageTitleWrapper = "membership-module--page-title-wrapper--+4wpm";